export enum ContactType {
  Client = 'Client',
  Organisation = 'Organisation',

  // Not persisted
  All = 'All types',
}

export function StringToContactType(s: string): ContactType | undefined {
  switch (s.toLowerCase()) {
    case 'client':
      return ContactType.Client;
    case 'organisation':
      return ContactType.Organisation;
  }
  return undefined;
}
